import { Link } from '../lib/routerCompat';

export default function NotFoundView(): JSX.Element {
  return (
    <div className="view" style={{ textAlign: 'center', padding: '96px 24px' }}>
      <div
        style={{
          fontFamily: 'var(--cinzel)',
          fontSize: 64,
          color: 'var(--gold)',
          fontWeight: 700,
          letterSpacing: 6,
        }}
      >
        404
      </div>
      <div className="gold-divider">
        <span className="divider-gem">◆</span>
      </div>
      <div className="section-header" style={{ marginBottom: 12 }}>
        This Vault Is Empty
      </div>
      <p
        style={{
          color: 'var(--text-muted)',
          fontFamily: 'var(--cormorant)',
          fontSize: 18,
          marginBottom: 28,
        }}
      >
        The page you&rsquo;re looking for doesn&rsquo;t exist or has been moved.
      </p>
      <Link to="/" className="btn-gold" style={{ textDecoration: 'none', padding: '12px 28px' }}>
        Return Home
      </Link>
    </div>
  );
}
